import React, { useState, useEffect } from 'react';
import getFacility from '../../shared/api/getFacility';
import Layout from '../../shared/components/Layout';
import Header from '@/features/facility/welcome/components/Header';
import Footer from '@/features/facility/top/components/Footer';
import CompanyOverviewMain from '../components/CompanyOverviewMain';

const CompanyOverview = () => {
  const [isLogin, setLogin] = useState<boolean>(false)

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        await getFacility();
        setLogin(true);
      } catch {
        setLogin(false);
      }
    };

    fetchFacility();
  }, []);

  const member = (
    <Layout>
      <CompanyOverviewMain />
    </Layout>
  );

  const other = (
    <React.Fragment>
      <Header />
      <CompanyOverviewMain />
      <Footer />
    </React.Fragment>
  )

  return (
    <React.Fragment>
      { isLogin ? member : other }
    </React.Fragment>
  );
};

export default CompanyOverview;
